import { render, staticRenderFns } from "./AddressImage.vue?vue&type=template&id=01610e12&scoped=true&"
import script from "./AddressImage.vue?vue&type=script&lang=js&"
export * from "./AddressImage.vue?vue&type=script&lang=js&"
import style0 from "./AddressImage.vue?vue&type=style&index=0&id=01610e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01610e12",
  null
  
)

export default component.exports